module.exports = __webpack_public_path__ + "31f067d6b68b2385a21c31d869707a3e.svg";